import {
  FETCHING_VIDEOS_SUCCESS,
  FETCHING_VIDEOS_FAILED,
  FETCHING_VIDEOS,

  CREATING_VIDEOS,
  CREATING_VIDEO_FAILED,
  CREATING_VIDEO_SUCCESS,

  DELETING_VIDEOS,
  DELETING_VIDEOS_COMPLETE,
  DELETING_VIDEOS_FAILED,

  GET_SINGLE_VIDEO,
  GET_SINGLE_VIDEO_COMPLETE,
  GET_SINGLE_VIDEO_FAILED,
} from "./types";
import {
  fetchVideosService,
  addVideoViaLinkService,
  addVideoViaFileService,
  fetchVideoForAdminService,
  deleteVideoService,
  fetchSingleVideoService
} from "./api";
import { toast } from 'react-toastify';


export const fetchSingleVideoAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_VIDEO });
    const response = await fetchSingleVideoService(id)();
    dispatch({ type: GET_SINGLE_VIDEO_COMPLETE, video: response.data });
  } catch (error) {
    dispatch({ type: GET_SINGLE_VIDEO_FAILED });
  }
}; 
export const deleteVideosAction =
  ({ token, ids }) =>
  async (dispatch) => {
    try {
      dispatch({type: DELETING_VIDEOS, ids })
      await deleteVideoService(token, { ids })();
     dispatch({type: DELETING_VIDEOS_COMPLETE, ids })
     toast.success('Delete Successful')
    } catch (error) {
      dispatch({type: DELETING_VIDEOS_FAILED});
      toast.error(error?.message || error?.data?.message || 'Delete Failed')
    }
  };


export const fetchVideoAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_VIDEOS });
    const response = await fetchVideosService(params);
    const {
      data: { stories },
      headers: { total, per_page },
    } = response;

    dispatch({
      type: FETCHING_VIDEOS_SUCCESS,
      videos: { data: stories, total, per_page },
    });
  } catch (error) {
    dispatch({ type: FETCHING_VIDEOS_FAILED });
  }
};
export const fetchVideoForAdminAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_VIDEOS });
    const response = await fetchVideoForAdminService(params)();
    dispatch({
      type: FETCHING_VIDEOS_SUCCESS,
      videos: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCHING_VIDEOS_FAILED });
  }
};

export const createVideoAction = ({
  token,
  type,
  title,
  countryId: country_id,
  link: videoLink,
  description,
  disease: disease_id,
}) => async (dispatch) => {
  try {
    dispatch({ type: CREATING_VIDEOS });
    const response = await addVideoViaLinkService(token)({
      country_id,
      description,
      disease_id,
      videoLink,
      title,
      type,
    });

    dispatch({ type: CREATING_VIDEO_SUCCESS, video: response?.data });
    toast.success('Video added successfully')
    return true;
  } catch (error) {
    dispatch({ type: CREATING_VIDEO_FAILED });
    toast.error(
      error?.data?.message || error?.message || "we could not upload the media file"
    );
  }
};


export const createVideoViaFileAction = ({
  token,
  description,
  title,
  type,
  thumbnail,
  file: video,
  disease: disease_id,
  countryId: country_id,
}) => async (dispatch) => {
  try {
    dispatch({ type: CREATING_VIDEOS})
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("country_id", country_id);
    formData.append("video", video);
    formData.append("thumbnail", thumbnail);
    formData.append("type", type);
    formData.append("disease_id", disease_id);

    const response = await addVideoViaFileService(token)(formData);
    dispatch({ type: CREATING_VIDEO_SUCCESS, video: response?.data });
    toast.success('Video added successfully')
    return true;
   
  } catch (error) {
    dispatch({ type: CREATING_VIDEO_FAILED });
    toast.error(
      error?.data?.message || error?.message || "we could not upload the media file"
    );
  }
} 
